module.exports = __webpack_public_path__ + "media/images/png/man-870c29b8d94e8775ff50850827d6836e.png";